/**
 * Move a cursor past a trailing schema placeholder suffix before splitting.
 */

import { EditorState, TextSelection, Transaction } from 'prosemirror-state'

import { getLogicalEndSuffix } from '#util/prosemirrorHelpers/wrapped-block-helpers'

/**
 * Advance past the closing suffix at a logical block end, preserving ranges.
 */
export function maybeSidestepLastChar(state: EditorState): Transaction {
  const { tr } = state
  if (!state.selection.empty) return tr

  const { $anchor } = state.selection
  const suffix = getLogicalEndSuffix($anchor)
  if (!suffix) return tr

  return tr.setSelection(
    TextSelection.create(tr.doc, $anchor.pos + suffix.length),
  )
}
